import type { NotificationBroadcastInterventionTransitionPayload } from "../notification-broadcast.type";

import { NOTIFICATION_BROADCAST_TYPE } from "../notification-broadcast.enum";
import {
  isNotificationBroadcastNamedModel,
  isValidNotificationBroadcastBase,
} from "../notification-broadcast.helper";

export const isNotificationBroadcastInterventionTransitionPayload = (
  payload: unknown
): payload is NotificationBroadcastInterventionTransitionPayload =>
  isValidNotificationBroadcastBase(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.INTERVENTION_TRANSITION &&
  "interventions" in payload &&
  Array.isArray(payload.interventions) &&
  payload.interventions.length > 0 &&
  payload.interventions.every(isNotificationBroadcastNamedModel) &&
  "user" in payload &&
  isNotificationBroadcastNamedModel(payload.user) &&
  "state" in payload &&
  typeof payload.state === "string";
